import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router";

const Swal = require("sweetalert2");

const Signature = ({
  signatureNaturalPersonForm,
  signatureNaturalPersonReset,
  successfulSignatureNaturalPerson,
  errorsSignatureNaturalPerson,
  naturalPersonSignature,
  signatureJuridicalPersonForm,
  signatureJuridicalPersonReset,
  successfulSignatureJuridicalPerson,
  errorsSignatureJuridicalPerson,
  juridicalPersonSignature,
}) => {
  const history = useHistory();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    setValue,
  } = useForm();

  const onSubmit = (data) => {
    const file_firma = data.file_firma && data.file_firma[0];
    switch (data.type) {
      case "PersonaNatural":
        signatureNaturalPersonForm({
          codigo_verificacion: data.codigo_verificacion,
          file_firma: file_firma,
        });
        break;
      case "PersonaJuridica":
        signatureJuridicalPersonForm({
          codigo_verificacion: data.codigo_verificacion,
          file_firma: file_firma,
        });
        break;
    }
  };

  useEffect(() => {
    if (successfulSignatureNaturalPerson) {
      Swal.fire(
        "Proceso exitoso!",
        "El formulario firmado exitosamente",
        "success"
      ).then((result) => {
        history.push("/solicitud");
        reset();
        signatureNaturalPersonReset();
      });
    }
  }, [successfulSignatureNaturalPerson]);

  useEffect(() => {
    if (successfulSignatureJuridicalPerson) {
      Swal.fire(
        "Proceso exitoso!",
        "El formulario firmado exitosamente",
        "success"
      ).then((result) => {
        history.push("/solicitud");
        reset();
        signatureJuridicalPersonReset();
      });
    }
  }, [successfulSignatureJuridicalPerson]);

  return (
    <div className="container">
      {/* <!-- Outer Row --> */}
      <div className="row justify-content-center">
        <div className="col-xl-10 col-lg-12 col-md-9">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              {/* <!-- Nested Row within Card Body --> */}
              <div class="card-header text-center">
                <img
                  src="https://scontent.fpei1-1.fna.fbcdn.net/v/t1.18169-9/26165289_375180046264698_4541341282296257735_n.jpg?_nc_cat=105&ccb=1-7&_nc_sid=09cbfe&_nc_eui2=AeHP4_-jE6tnHpEukkE9A1_Si5YvJp7SzqyLli8mntLOrGteNWQT18pf2wCBzqF0EiLFxPvh36NhYaWz5-HHcjaw&_nc_ohc=mkq9eaQqe08AX-Conic&_nc_ht=scontent.fpei1-1.fna&oh=00_AT8L7s-hDwrwVYcgp3oIxfZQkBjdwyJW5mwWgEGkvLMqJg&oe=6324C2B8"
                  width="80px"
                  alt=""
                  srcSet
                  style={{
                    paddingBottom: "10px",
                    width: "150px",
                  }}
                />
                <p>
                  FORMATO ÚNICO DE CREACIÓN / ACTUALIZACIÓN CLIENTES Y /O
                  PROVEEDORES
                </p>
              </div>
              <div className="card-body">
                <div className="card-header ">FIRMAR DOCUMENTO</div>
                <form onSubmit={handleSubmit(onSubmit)} autocomplete="off">
                  <div className="row mt-3">
                    <div className="form-group col-md-12">
                      <label className="form-label">Tipo de persona</label>
                      <select
                        className="form-control form-control-user form-select"
                        name="type"
                        {...register("type", { required: true })}
                      >
                        <option value="">Seleccione una opción</option>
                        <option value="PersonaNatural">Persona Natural</option>
                        <option value="PersonaJuridica">
                          Persona Juridica
                        </option>
                      </select>
                    </div>
                    <div className="form-group col-md-12">
                      <label className="form-label">
                        Identificación solicitud
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-user"
                        name="codigo_verificacion"
                        {...register("codigo_verificacion", { required: true })}
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <label className="form-label">Documento firmado</label>
                      <input
                        id
                        type="file"
                        className="form-control form-control-user"
                        name="file_firma"
                        {...register("file_firma", { required: true })}
                      />
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="submit" class="btn btn-secondary">
                      Enviar
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger"
                      onClick={() => {
                        history.push("/solicitud");
                      }}
                    >
                      Cancelar
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    successfulSignatureNaturalPerson:
      state.naturalPersonState.successfulSignatureNaturalPerson,
    errorsSignatureNaturalPerson:
      state.naturalPersonState.errorsSignatureNaturalPerson,
    naturalPersonSignature: state.naturalPersonState.naturalPersonSignature,
    successfulSignatureJuridicalPerson:
      state.juridicalPersonState.successfulSignatureJuridicalPerson,
    errorsSignatureJuridicalPerson:
      state.juridicalPersonState.errorsSignatureJuridicalPerson,
    juridicalPersonSignature:
      state.juridicalPersonState.juridicalPersonSignature,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signatureNaturalPersonForm: (payload) =>
      dispatch({
        type: "SIGNATURE_NATURAL_PERSON_REQUEST",
        value: payload,
      }),
    signatureNaturalPersonReset: () =>
      dispatch({
        type: "SIGNATURE_NATURAL_PERSON_RESET",
      }),
    signatureJuridicalPersonForm: (payload) =>
      dispatch({
        type: "SIGNATURE_JURIDICAL_PERSON_REQUEST",
        value: payload,
      }),
    signatureJuridicalPersonReset: () =>
      dispatch({
        type: "SIGNATURE_JURIDICAL_PERSON_RESET",
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Signature);
